"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _q = _interopRequireDefault(require("q"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../lang/en.lyaml"));

var _registerAllData = _interopRequireDefault(require("I18n/init/register/lazy/registerAllData"));

var _I18nContext = _interopRequireDefault(require("./context/I18nContext"));

require("I18n/init/data/baseLocales");

require("I18n/init/data/publicLocales");

require("I18n/init/data/currency");

var _UIApplication = _interopRequireDefault(require("UIComponents/app/UIApplication"));

var _reactRhumb = require("react-rhumb");

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV4"));

var _reactRedux = require("react-redux");

var _configureStore = _interopRequireDefault(require("./utils/configureStore"));

var _AppActions = require("./actions/AppActions");

var _NotificationList = _interopRequireDefault(require("ReduxMessenger/components/NotificationList"));

var _reactRouterDom = require("react-router-dom");

var _Routes = _interopRequireDefault(require("./components/Routes"));

var _apiClient = require("./utils/apiClient");

var _usageTracker = require("./utils/usageTracker");

var _isThenable = _interopRequireDefault(require("hs-promise-utils/isThenable"));

var _history = require("./utils/history");

var _env = require("./utils/env");

var _WindowDimensionsProvider = _interopRequireDefault(require("ecosystem-marketplace-core/components/providers/WindowDimensionsProvider"));

var _WelcomeModalContainer = _interopRequireDefault(require("./containers/WelcomeModalContainer"));

// Imports info on what base locales we support in I18n
// Usually used in Language/Locale selects
// Imports info on what extra locales we support in I18n
// (ie languages we support for our user's users)
// Usually used in Language/Locale selects
// Imports all currency data
// Needed if you render currency anywhere
// Rhumb
// Redux
// Configure the router
var FeedbackLoader = (0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'Feedback' */
  'feedback-loader').then(function (t) {
    return {
      default: t
    };
  });
});

var App = /*#__PURE__*/function () {
  function App(_ref) {
    var apiClient = _ref.apiClient,
        rootUrl = _ref.rootUrl,
        usageTracker = _ref.usageTracker,
        _ref$ApplicationCompo = _ref.ApplicationComponent,
        ApplicationComponent = _ref$ApplicationCompo === void 0 ? _UIApplication.default : _ref$ApplicationCompo,
        _ref$RoutesComponent = _ref.RoutesComponent,
        RoutesComponent = _ref$RoutesComponent === void 0 ? _Routes.default : _ref$RoutesComponent,
        _ref$blockingActions = _ref.blockingActions,
        blockingActions = _ref$blockingActions === void 0 ? [] : _ref$blockingActions,
        _ref$isAdminPreview = _ref.isAdminPreview,
        isAdminPreview = _ref$isAdminPreview === void 0 ? false : _ref$isAdminPreview,
        _ref$isPublic = _ref.isPublic,
        isPublic = _ref$isPublic === void 0 ? false : _ref$isPublic,
        I18nProvider = _ref.I18nProvider;
    (0, _classCallCheck2.default)(this, App);

    this.setDebug = function (key) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return _env.setDebug.apply(void 0, [key].concat(args));
    };

    this.setDebugGate = function (gate) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return _env.setDebugGate.apply(void 0, [gate].concat(args));
    };

    (0, _apiClient.setApiClient)(apiClient);
    (0, _usageTracker.setUsageTracker)(usageTracker);
    this.ApplicationComponent = ApplicationComponent;
    this.blockingActions = blockingActions;
    this.isAdminPreview = isAdminPreview;
    this.isPublic = isPublic;
    this.rootUrl = rootUrl;
    this.I18nProvider = I18nProvider;
    this.RoutesComponent = RoutesComponent;
  }

  (0, _createClass2.default)(App, [{
    key: "start",
    value: function start() {
      var _this = this;

      if ((0, _env.debug)()) {
        window.appInstance = this;
        (0, _env.logDebugging)();
      }

      var storeReady = this.startRedux();

      var langAvailable = _q.default.Promise.all([this.I18nProvider.register(_en.default), (0, _registerAllData.default)(this.I18nProvider)]);

      return storeReady.then(function () {
        if (!(_this.isPublic || _this.isAdminPreview)) {
          var user = _this.store.getState().auth.user;

          _this.I18nProvider.setLocale({
            locale: user.locale,
            langEnabled: user.lang_enabled
          });
        }

        return langAvailable.then(function () {
          _this.store.dispatch((0, _AppActions.startApp)());

          _this.startRouter(_this.I18nProvider);
        });
      }).done();
    }
  }, {
    key: "startRedux",
    value: function startRedux() {
      var _this2 = this;

      this.store = (0, _configureStore.default)();
      var promises = [];
      this.blockingActions.forEach(function (actionCall) {
        var maybePromise = _this2.store.dispatch(actionCall());

        if ((0, _isThenable.default)(maybePromise)) {
          promises.push(maybePromise);
        }
      });
      return _q.default.Promise.all(promises);
    }
  }, {
    key: "startRouter",
    value: function startRouter(i18nProvider) {
      var ApplicationComponent = this.ApplicationComponent,
          RoutesComponent = this.RoutesComponent,
          rootUrl = this.rootUrl;
      this.history = (0, _history.createHistory)(rootUrl);
      (0, _reactDom.render)(_react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _historyAdapterV.default)(this.history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_I18nContext.default.Provider, {
        value: i18nProvider
      }, _react.default.createElement(_WindowDimensionsProvider.default, null, _react.default.createElement(_reactRouterDom.Router, {
        history: this.history
      }, _react.default.createElement(ApplicationComponent, {
        name: "ecosystem-marketplace-apps-ui"
      }, _react.default.createElement(_NotificationList.default, null), _react.default.createElement(RoutesComponent, null))), !(this.isPublic || this.isAdminPreview) && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_WelcomeModalContainer.default, null), _react.default.createElement(_react.Suspense, {
        fallback: _react.default.createElement("span", null)
      }, _react.default.createElement(FeedbackLoader, null)))))))), document.getElementsByClassName('page')[0]);
    } // Debug methods

  }]);
  return App;
}();

exports.default = App;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/App.js
// module id = 613
// module chunks = 209 210 211 212